export default function DotLoader({ className = "" }: { className?: string }): React.ReactElement {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <span className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:0ms]" />
      <span className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:150ms]" />
      <span className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:300ms]" />
    </div>
  );
}

